import React, { useState } from "react";
import MaskedInput from "react-text-mask";
import ReCAPTCHA from "react-google-recaptcha";
import { Form, withFormik } from "formik";

import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import { dataSourceV2 } from "commons-ui/core/DataSource";
import MuiSelect from "commons-ui/core/MuiSelect";

export const emailRe =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function ContactForm(props) {
  const { values, errors, touched, setFieldValue, isSubmitting } = props;
  const [captcha, setCaptcha] = useState(false);

  return (
    <Form
      noValidate=""
      className="u-paddingVertical15 u-sizeFullWidth"
      style={{ maxWidth: 600 }}
    >
      <div className="">
        <h2 className="u-fontSize18 u-flexCenter u-height40 u-fontWeightBold">
          Contact us online:
        </h2>
        <p>
          or by email{" "}
          <a href="mailto: cs@piroshkybakery.com" className="link">
            cs@piroshkybakery.com
          </a>
        </p>
      </div>
      <div className="u-marginTop10">
        <div className="u-flexCenter u-xs-flexColumn">
          <TextField
            error={errors.name && touched.name}
            label="Name"
            helperText={errors.name && touched.name ? errors.name : ""}
            margin="dense"
            variant="outlined"
            className="u-sizeFullWidth u-marginVertical12 u-marginRight10 u-xs-marginRight0"
            onChange={(e) => setFieldValue("name", e.target.value)}
            value={values.name}
          />
          <TextField
            error={errors.email && touched.email}
            label="Email"
            helperText={errors.email && touched.email ? errors.email : ""}
            margin="dense"
            variant="outlined"
            className="u-sizeFullWidth u-marginVertical12 u-marginLeft10 u-xs-marginLeft0"
            onChange={(e) => setFieldValue("email", e.target.value)}
            value={values.email}
          />
        </div>

        <div className="u-flexCenter u-xs-flexColumn">
          <TextField
            error={errors.phone && touched.phone}
            helperText={errors.phone && touched.phone ? errors.phone : ""}
            label="Phone"
            className="u-sizeFullWidth u-marginVertical12 u-marginRight10 u-xs-marginRight0"
            value={values.phone}
            variant="outlined"
            margin="dense"
            onChange={(e) => setFieldValue("phone", e.target.value)}
            InputProps={{ inputComponent: PhoneMask }}
          />
          <MuiSelect
            items={[
                { name: "Refund request", value: "refund_request"},
                { name: "Compliment or Complaint", value: "compliment_or_complaint"},
                { name: "Question or Suggestion", value: "question_or_suggestion"},
                { name: "Business Collaboration", value: "businnes_colab"},
                { name: "Catering", value: "catering"},
                { name: "Other", value: "other" }
            ]}
            selected={values.subject}
            htmlFor={"state_select"}
            label="Subject"
            margin="dense"
            className="u-marginVertical12 u-sizeFullWidth u-marginLeft10 u-xs-marginLeft0"
            onSelect={(type) => setFieldValue("subject", type)}
          />
        </div>
        <TextField
          error={errors.content && touched.content}
          label="Write your question"
          helperText={errors.content && touched.content ? errors.content : ""}
          multiline
          rows={3}
          margin="dense"
          variant="outlined"
          className="u-sizeFullWidth u-marginVertical12"
          onChange={(e) => setFieldValue("content", e.target.value)}
          value={values.content}
        />
      </div>
      <div className="u-marginTop12 u-marginBottom15">
        <ReCAPTCHA
          sitekey="6LdX_i0aAAAAAHtPT1moyqGPUia1EZA9frblgKBt"
          onChange={(value) => setCaptcha(true)}
        />
      </div>
      <div className="u-flexCenter u-marginTop10">
        <Button
          variant="outlined"
          type="submit"
          size="large"
          className="button-secondary"
          disabled={!captcha || isSubmitting}
        >
          Submit
        </Button>
      </div>
    </Form>
  );
}

const defaultValues = (password) => ({
  name: "",
  email: "",
  phone: "",
  subject: "",
  content: "",
});

export default ContactForm = withFormik({
  mapPropsToValues: (props) => defaultValues(props.password),

  validate: (values, props) => {
    let errors = {};
    if (values.email && !emailRe.test(values.email)) {
      errors.email = "Incorrect email";
    }
    if (!values.email && !values.phone) {
      errors.email = "Cannot be empty";
    }
    if (!values.subject) {
      errors.subject = "Cannot be empty";
    }
    return errors;
  },

  handleSubmit: (values, props) => {
    const { items, onSuccess, ecommerceStoreId, apiPath } = props.props;

    const newValues = {...values};
    newValues.content = "Subject: " + (values.subject || "") + ". " + (values.content || "");
    dataSourceV2("customer_message_create", {
      data: {
        item: {
          ...newValues,
          ecommerce_store_id: ecommerceStoreId,
          email_to: "cs@piroshkybakery.com",
        },
      },
      url: apiPath,
    }).then((v) => {
      props.setSubmitting(false);
      if (v.item) {
        onSuccess();
      }
    });
  },
  validateOnChange: false,
  validateOnBlur: false,
})(ContactForm);

function PhoneMask(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        "+",
        "1",
        " ",
        "(",
        /[1-9]/,
        /\d/,
        /\d/,
        ")",
        " ",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={"_"}
    />
  );
}
